module.exports = __webpack_public_path__ + "static/img/manual_zh_16.f4c61e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_16.png
// module id = enzE
// module chunks = 4